import type FreeBusyType from './FreeBusyType';
import type { ScheduleInformation } from 'owa-graph-schema';

interface FreeBusyRow extends ScheduleInformation {
    // Long-term, this interface should go away and ScheduleInformation should be consumed
    // directly. This is being left alone for now to reduce code churn.
    // Work Item 162149: Clean up free/busy cache schema once GetSchedule transition is complete
    mergedFreeBusy: FreeBusyType[];
}

export default FreeBusyRow;

export function emptyFreeBusyRow(size: number, value: FreeBusyType): FreeBusyType[] {
    const result = [];
    for (let i = 0; i < size; i++) {
        result[i] = value;
    }
    return result;
}
